<script>
import pDebounce from 'p-debounce';
import MultitabPicker from '~/components/common/multitab-picker';
import common from '~/scripts/mixins/international/common';
import { INTERNATIONAL_GET_AIRPORTS } from '~endpoints';

export default {
    extends: MultitabPicker,

    mixins: [common],

    props: {
        filter: {
            type: Function,
            default: () => true,
        },
        itemTitle: {
            type: String,
            default: 'name',
        },
        itemKey: {
            type: String,
            default: 'domainCode',
        },
    },

    data () {
        return {
            fetchedCities: [],
        };
    },

    computed: {
        airports () {
            return (this.$store.getters['international/airports'] || []).filter(this.filter);
        },

        options () {
            return this.fetchedCities;
        },
    },

    mounted () {
        this.onSearchChange();
        this._fetchCitiesDebounced = pDebounce(this.fetchCities, 200);

        if (this.$refs.dropdown) this.$refs.dropdown.style.maxHeight = '370px';
    },

    methods: {
        onSearchChange (query) {
            if (!query) {
                this.fetchedCities = this.airports;
                return;
            }
            this._fetchCitiesDebounced(query).then(res => {
                this.fetchedCities = this.inputValue ? res : this.airports;
            }).catch(() => {
                this.fetchedCities = [];
            });
        },

        fetchCities (query) {
            if (!query) {
                return;
            }
            this.loading = true;
            // Query for asyncGetCities
            const param = 'q={"ct":"' + query + '"}';
            return this.$axios.$get(INTERNATIONAL_GET_AIRPORTS, {
                params: {
                    filter: param,
                },
            }).then(({ result }) => {
                result = (result.items || []).filter(this.filter);
                this.fetchedCities = this.groupResults(result);
                return this.fetchedCities;
            }).finally(() => {
                this.loading = false;
            });
        },

        groupResults (result) {
            const { cities, airports } = result.reduce((carry, item, i) => {
                item.index = i;
                carry[this.isCity(item) ? 'cities' : 'airports'].push(item);
                return carry;
            }, { cities: [], airports: [] });
            cities.forEach(city => {
                city.airports = airports.filter(el => el.city.code === city.city.code);
                city.airports.forEach(el => {
                    el.subcity = true;
                    airports.splice(airports.indexOf(el), 1);
                    city.index = Math.min(city.index, el.index);
                });
            });

            result = airports.concat(cities);
            result.sort((a, b) => a.index - b.index);
            return result.reduce((carry, item) => {
                return carry.concat(item).concat(item.airports || []);
            }, []);
        },

        label (v) {
            return v && v.name ? `${v.city.name}, ${v.domainCode.substr(0, 3)}` : '';
        },

        onFocus (e) {
            MultitabPicker.methods.onFocus.call(this, e);
            this.inputValue = '';
            this.onSearchChange('');
        },

        onClose () {
            this.inputValue = this.label(this.value);
        },

        valueWatcher (t) {
            this.inputValue = this.label(t);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';

.multitab-picker {

    &__dropdown {
        min-width: 340px;
    }

    &__items > li > a {
        padding: 10px;
    }
}
</style>
